import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

interface ComingSoonProps {
  pageName?: string;
  returnPath?: string;
  returnText?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  pageName = "This Feature",
  returnPath = "/",
  returnText = "Return to Home",
}) => {
  return (
    <Container className="py-5 my-5">
      <Row className="justify-content-center text-center">
        <Col md={8} lg={6}>
          <div className="mb-4">
            <i
              className="bi bi-clock-history text-primary"
              style={{ fontSize: "4rem" }}
            ></i>
          </div>
          <h1 className="mb-4">Coming Soon</h1>
          <h4 className="text-muted mb-4">{pageName} is under development</h4>
          <p className="lead mb-5">
            We're working hard to bring you this feature. Please check back
            later for updates.
          </p>
          {/* Fix for TypeScript error - using regular button with onClick */}
          <Button
            variant="primary"
            size="lg"
            onClick={() => (window.location.href = returnPath)}
          >
            <i className="bi bi-arrow-left me-2"></i> {returnText}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default ComingSoon;
